import { useAppSelector } from "../../../hooks";
import { } from "../../../store/slices/uiSlice";
import MapIcon from "../../../assets/icons/MapIcon";
import MessengerIcon from "../../../assets/icons/MessengerIcon";
import PhoneIcon from "../../../assets/icons/PhoneIcon";
import ZaloIcon from "../../../assets/icons/ZaloIcon";
import { Link } from "react-router-dom";
import WhatsAppIcon from "../../../assets/icons/WhatsAppIcon";
import { getShopState } from "../../../store";
export default function Header() {
    const { shopInfo } = useAppSelector(getShopState);
    
    return (
        
        <div className="grid grid-cols-4 bg-white max-md:grid-cols-1 max-md:pt-8">
            <div className="bg-[#fff] sm:hidden w-full fixed top-0 z-50"></div>
            <div className="flex justify-center items-center">
                <Link to="/" className={window.location.pathname === '/checkout'
                    ? "max-md:pt-0 flex justify-center items-center min-h-fit"
                    : "max-md:pt-12 flex justify-center items-center min-h-fit"
                }>
                    <img src={shopInfo.store_logo_url} alt="logo" className="max-w-[220px] max-md:max-w-[80%]" />
                </Link>
            </div>
            <div className="flex flex-col gap-2 col-span-3 p-10 max-md:p-5">
                <h1 className="text-3xl font-medium uppercase max-md:text-center">{shopInfo.store_title}</h1>
                <p className="text-[#747C87] text-sm">{shopInfo.store_description}</p>
                <div className="flex items-center gap-4">
                    {!!shopInfo.shop_phone &&
                        <div className="flex items-center gap-4">
                            <PhoneIcon />
                            <p className="text-sm">{shopInfo.shop_phone}</p>
                        </div>
                    }
                    {!!shopInfo.store_zalo && <a target="_blank" rel="noreferrer" href={shopInfo.store_zalo}> <ZaloIcon /></a>}
                    {!!shopInfo.store_facebook && <a target="_blank" rel="noreferrer" href={shopInfo.store_facebook}><MessengerIcon /></a>}
                    {!!shopInfo.store_whatsapp && <a target="_blank" rel="noreferrer" href={shopInfo.store_whatsapp}><WhatsAppIcon /></a>}
                </div>
                {!!shopInfo.shop_address &&
                    <div className="flex items-center gap-4">
                        <MapIcon />
                        <p className="text-sm">{shopInfo.shop_address}</p>
                    </div>
                }
            </div>
        </div>
    );
}